import { ForgotPasswordPage } from '@page/forgot-password/forgot-password.page';
import { LoginCallbackPage } from '@page/login-callback/login-callback.page';
import { LoginMfaPage } from '@page/login-mfa/login-mfa.page';
import { LoginPage } from '@page/login/login.page';
import { NewPasswordPage } from '@page/new-password/new-password.page';
import { SignUpVeloryPage } from '@page/sign-up-velory/sign-up-velory.page';
import { SignUpPage } from '@page/sign-up/sign-up.page';

import { SignUpVeloryAside } from '@component/aside/sign-up-velory/sign-up-velory.aside';
import { SignUpAside } from '@component/aside/sign-up/sign-up.aside';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const UnsafeRoutes: RouteConfigInterface[] = [
  {
    ...pageNameLoader(RouteEnum.Login),
    element: <LoginPage />,
  },
  {
    ...pageNameLoader(RouteEnum.LoginMfa),
    element: <LoginMfaPage />,
  },
  {
    ...pageNameLoader(RouteEnum.LoginCallback),
    element: <LoginCallbackPage />,
  },
  {
    ...pageNameLoader(RouteEnum.SignUp),
    Aside: SignUpAside,
    element: <SignUpPage />,
  },
  {
    ...pageNameLoader(RouteEnum.SignUpVelory),
    Aside: SignUpVeloryAside,
    element: <SignUpVeloryPage />,
  },
  {
    ...pageNameLoader(RouteEnum.ForgotPassword),
    element: <ForgotPasswordPage />,
  },
  {
    ...pageNameLoader(RouteEnum.NewPassword),
    element: <NewPasswordPage />,
  },
];
